import { Component, Show } from 'solid-js'

interface Props {
  title: string
  value: string
  onClick: (value: string, replacePrompt: boolean) => void
  replacePrompt?: boolean
  isSelected?: boolean
}

const GenerateImageOptionButton: Component<Props> = (props) => {
  return (
    <button
      onClick={() => props.onClick(props.value, props.replacePrompt || false)}
      class={`flex flex-row rounded-md border px-[10px] py-[6px] ${
        props.isSelected
          ? 'border-cosplay-purple bg-cosplay-purple/20'
          : 'border-cosplay-gray-100/50 bg-[#171717]'
      }`}
    >
      <Show when={!props.isSelected}>
        <img src="/images/generate-image-plus-btn.png" class="h-[17px] w-[17px]" />
      </Show>
      <Show when={props.isSelected}>
        <div class="flex h-[17px] w-[17px] items-center justify-center rounded-full bg-cosplay-purple text-white">
          <span class="text-xs font-bold">−</span>
        </div>
      </Show>
      <p class="m-0 ml-2 p-0 text-xs">{props.title}</p>
    </button>
  )
}

export default GenerateImageOptionButton
